import { Injectable } from "@angular/core";
import { NewJobPopoverArgs, NewJobPopoverComponent } from "../modules-shared/new-job-popover/new-job-popover.component";
import { PopoverController } from "ionic-angular";
import { Job } from "../business-objects/job/job.model";
import { NewJobPopoverResult } from "../modules-shared/new-job-popover/new-job-popover-result.model";
import { BaseController } from "../../core/controllers/base.controller";
import { Account } from "../business-objects/account/account.model";
import { FormInlined } from "../business-objects/form/form.model";
import * as Q from "q";
import { VasAppFacade } from "../services/vas-app-facade.service";

@Injectable()
export class AppJobsController extends BaseController {

    protected account: Account;

    constructor(
        protected appFacade: VasAppFacade,
        protected popoverController: PopoverController
    ) {
        super();

        this.appFacade.objects.account.store
            .getActive()
            .takeUntil(this.ngUnsubscribe)
            .subscribe(account => {
                this.account = account;
            });
    }

    // @todo change signature to ($event, account: Account, job?: Job)
    getForm($event, job?: Job, account?: Account): Promise<void> {
        return Promise.resolve();
    }


}



// WEBPACK FOOTER //
// ./src/vas/controllers/app-jobs.controller.ts